export default function Page() {
  return <main>Page not found!🤷‍♂️</main>
}
